import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import BaseComponent from './BaseComponent';
import Style from './StudyGoal.cssmodule.less';
import { clickButton, updateItemIndex } from '../../actions/Modal';
import 'simplebar';
import 'simplebar/dist/simplebar.css';

class StudyGoal extends BaseComponent {
    constructor(props) {
        super(props);
        this.setTheme(props.theme);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    setTheme(theme) {
        const themeStyle = this.getTheme(theme, 'STUDY_GOAL');
        this.Style = themeStyle || Style;
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    createRenderView(content) {
        const wrapper = Entry.createElement('div');
        if (content) {
            $('body').append(wrapper);
            wrapper.addClass(this.Style.editorBlock);
            wrapper.addClass('blocks');
            wrapper.contentEditable = false;
            $(wrapper).attr('block', content);
            const renderView = new Entry.RenderView(wrapper, 'LEFT_MOST');
            renderView.changeCode(new Entry.Code(JSON.parse(content)), true);
            $(wrapper).detach();
        }
        return wrapper;
    }

    render() {
        const {
            itemIndex = 0,
            maxIndex = 0,
            actions = {},
            item = {},
        } = this.props;
        const { updateItemIndex } = actions;
        const { title = '' } = item;
        return (
            <div>
                <div className={this.Style.popup_wrap}>
                    <div
                        className={`${this.Style.pop_header} ${this.Style.hint_header}`}
                    >
                        <strong className={this.Style.sjt}>{title}</strong>
                        <span className={this.Style.step}>
                            {itemIndex + 1}/{maxIndex}
                        </span>
                    </div>
                    <div className={this.Style.pop_cont}>
                        <div
                            className={this.Style.scroll_box}
                            data-simplebar
                            dangerouslySetInnerHTML={{
                                __html: item.content,
                            }}
                        ></div>
                        <span
                            className={classNames(
                                this.Style.btn_arr,
                                this.Style.prev,
                                { [this.Style.disabled]: itemIndex === 0 }
                            )}
                            onClick={() =>
                                updateItemIndex(Math.max(0, itemIndex - 1))
                            }
                        >
                            이전
                        </span>
                        <span
                            className={classNames(
                                this.Style.btn_arr,
                                this.Style.next,
                                {
                                    [this.Style.disabled]:
                                        itemIndex === maxIndex - 1,
                                }
                            )}
                            onClick={() =>
                                updateItemIndex(
                                    Math.min(itemIndex + 1, maxIndex - 1)
                                )
                            }
                        >
                            다음
                        </span>
                    </div>
                    <span
                        className={this.Style.pop_close}
                        onClick={(e) => this.handleButtonClick('close')}
                    >
                        팝업닫기
                    </span>
                </div>
            </div>
        );
    }
}

StudyGoal.displayName = 'StudyGoal';
StudyGoal.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton, updateItemIndex };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(undefined, mapDispatchToProps)(StudyGoal);



// WEBPACK FOOTER //
// ./components/ModalSet/StudyGoal.js